var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerGameTypeMysteryBountyMono(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.334 2c.519 0 .983.32 1.168.805l.45 1.178.005.017h1.616C13.387 4 14 4.69 14 5.48v6.04c0 .79-.613 1.48-1.427 1.48H11.5a.5.5 0 01-.5.5h-.5a.5.5 0 01-.5-.5H6a.5.5 0 01-.5.5H5a.5.5 0 01-.5-.5H3.427C2.613 13 2 12.31 2 11.52V5.48C2 4.69 2.613 4 3.427 4h1.616l.006-.017.449-1.178A1.25 1.25 0 016.666 2h2.668zM6.666 3a.25.25 0 00-.233.161L6.113 4h3.774l-.32-.839A.25.25 0 009.334 3H6.666z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11a.5.5 0 110 1 .5.5 0 010-1zM8.017 5a2.25 2.25 0 011.118 4.202 2.251 2.251 0 01-.635.243V10a.5.5 0 01-1 0V9a.5.5 0 01.5-.5h.01a1.252 1.252 0 001.256-1.247 1.25 1.25 0 00-2.333-.627.5.5 0 01-.866-.5A2.25 2.25 0 018.017 5z",
    fill: "#fff"
  })));
}
SvgPokerGameTypeMysteryBountyMono.displayName = 'PokerGameTypeMysteryBountyMono';
export default SvgPokerGameTypeMysteryBountyMono;